import React from "react";

import tail from "ramda/es/tail";

import useAuth from "../../routes/login/AuthContext";
import Api from "../../services/Api";
import { Editor } from "../Editor";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { Grid } from "../../UI/Grid";
import { Skeleton } from "../../UI/Skeleton";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { useSnackbar } from "../../hooks/useSnackbar";

export const CommunityInfo = () => {
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const [defaultValue, setDefaultValue] = React.useState("");
  const [editorState, onEditorStateChange] = React.useState("");
  const [isSetLoading, setSetLoading] = React.useState(false);
  const [isGetLoading, setGetLoading] = React.useState(true);

  React.useEffect(() => {
    const getData = async () => {
      setGetLoading(true);
      const { result } = await Api.getCommunityInfo(selectedNetworkId, await getAuthToken());

      if (result) {
        setDefaultValue(result.description);
      }
      setGetLoading(false);
    };

    getData();
  }, [selectedNetworkId]);

  const handleSave = React.useCallback(async () => {
    setSetLoading(true);

    const splittedState = editorState.split('<a href="');
    const parsedEditor = tail(splittedState).reduce((pv, cv) => {
      const cvLower = cv.toLowerCase();

      if (cvLower.startsWith("www.")) {
        return pv + '<a href="https://' + cv;
      }

      if (!cvLower.startsWith("www.") && !cvLower.startsWith("https://") && !cvLower.startsWith("http://")) {
        return pv + '<a href="https://www.' + cv;
      }

      return pv + '<a href="' + cv;
    }, splittedState[0]);

    const { error } = await Api.setCommunityInfo(selectedNetworkId, parsedEditor, await getAuthToken());

    if (error) {
      showErrorSnackbar();
    } else {
      showSuccessSnackbar("Successfully saved!");
    }

    setSetLoading(false);
    setDefaultValue(parsedEditor);
  }, [selectedNetworkId, editorState]);

  return (
    <Grid container spacing={2}>
      {isGetLoading && (
        <>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={20} width={140} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={100} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={33} width={200} />
          </Grid>
        </>
      )}
      {!isGetLoading && (
        <>
          <Grid item xs={12}>
            <Editor defaultValue={defaultValue} onChange={onEditorStateChange} />
          </Grid>
          <Grid item xs={12}>
            <Box maxWidth={200}>
              <ReadOnlyWrapper>
                <Button appearance="primary" onClick={handleSave} isLoading={isSetLoading} isDisabled={isSuperAdminRead()}>
                  Save
                </Button>
              </ReadOnlyWrapper>
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  );
};
